export * from '@pedrouid/environment';
//# sourceMappingURL=env.js.map